import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    d: 'M4.7999 3.6001H19.1999C19.8599 3.6001 20.4239 3.8401 20.8919 4.3081C21.3599 4.7761 21.5999 5.3401 21.5999 6.0001V14.4001C21.5999 15.0601 21.3599 15.6241 20.8919 16.0921C20.4239 16.5601 19.8599 16.8001 19.1999 16.8001H17.9999L11.9999 22.8001V16.8001H4.7999C4.1399 16.8001 3.5759 16.5601 3.1079 16.0921C2.6399 15.6241 2.3999 15.0601 2.3999 14.4001V6.0001C2.3999 5.3401 2.6399 4.7761 3.1079 4.3081C3.5759 3.8401 4.1399 3.6001 4.7999 3.6001ZM17.9999 6.0001H4.7999V7.2001H17.9999V6.0001ZM19.1999 9.6001H4.7999V10.8001H19.1999V9.6001ZM15.5999 13.2001H4.7999V14.4001H15.5999V13.2001Z',
                    fill: '#777777',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const TestimonialOutlined = React.forwardRef(IconComponent);
TestimonialOutlined.displayName = 'TestimonialOutlined';

export { TestimonialOutlined };
